/**
 * HOW LONG AGO, in words. The ladder, kept apart from the two shapes that ask for it.
 *
 * Two callers, two questions. The activity feed has an absolute timestamp and a `now`;
 * the machine list has an AGE in seconds and nothing else (`last_seen_age_s`, which is
 * what the BFF sends). They cannot share a signature, so they shared nothing — and the
 * machine list, having written only the part it needed, stopped at MINUTES. A machine
 * last seen three hours ago read "last seen 180m ago", and one last seen two days ago
 * read "last seen 2880m ago". The same ceiling that made a 5 GB upload read "5120.0 MB".
 *
 * So the LADDER lives here and both shapes call it. The feed keeps its own last step —
 * past a week it prints a date, which needs the absolute timestamp this cannot see.
 */

/** Seconds elapsed → 'now' / 'Xm ago' / 'Xh ago' / 'Xd ago'. Never a date: see above. */
export function relativeAge(seconds: number): string {
  // Clamped at zero: a clock skew that puts an event in the future must not print
  // "-3m ago", which reads as a bug in the row rather than in the clock.
  const d = Math.max(0, Math.floor(seconds))
  if (d < 45) return 'now'
  if (d < 3600) return `${Math.floor(d / 60)}m ago`
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`
  return `${Math.floor(d / 86400)}d ago`
}
